(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["medistik-collection-trust"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.md-collection-trust').forEach(function (root) {
    var tabs = root.querySelectorAll('.mdct-tab');
    var panels = root.querySelectorAll('.review-list-item');
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) { t.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.classList.toggle('active', i === j); });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medistik-compare-duel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-duel]').forEach(function (duel) {
    duel.querySelectorAll('.md-duel__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var side = chip.dataset.side;
        var index = chip.dataset.index;
        duel.querySelectorAll('.md-duel__chip[data-side="' + side + '"]').forEach(function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        duel.querySelectorAll('.md-duel__panel[data-side="' + side + '"]').forEach(function (p) {
          if (p.dataset.index === index) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medistik-feature-tiles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.md-ft__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tile = btn.closest('.md-ft__tile');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!tile || !panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
      tile.classList.toggle('is-open', !open);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medistik-lp-expect"] && !Shopify.designMode) return;
  try {
    
  /* The drawn line's behaviour lives here rather than in an inline <script>
     inside the section, because this page injects sections below the fold with
     innerHTML — and a script inserted that way never executes. Shopify loads
     this file itself, so it runs whether the section arrives with the page or
     later, and `shopify:section:load` re-runs it after a theme-editor change.
     Everything here is enhancement only: the copy is fully legible with none of
     it running, and reduced motion turns the whole thing on at once. */
  (function () {
    function init(root) {
      if (!root || root.dataset.mdExpectLine === 'on') return;
      var grid = root.querySelector('.md-lp-expect__grid');
      var items = [].slice.call(root.querySelectorAll('.md-lp-expect__item'));
      if (!grid || !items.length) return;
      root.dataset.mdExpectLine = 'on';

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        grid.style.setProperty('--md-lp-expect-progress', 1);
        items.forEach(function (i) { i.classList.add('is-active'); });
        return;
      }

      var ticking = false;
      function draw() {
        ticking = false;
        var r = grid.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        /* The rail fills between the grid reaching three quarters up the screen
           and its own bottom clearing the same mark. */
        var start = vh * 0.75;
        var span = r.height + vh * 0.25;
        var p = span > 0 ? (start - r.top) / span : 0;
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        grid.style.setProperty('--md-lp-expect-progress', p.toFixed(4));
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(draw);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      /* A hidden tab pauses animation frames, so a queued draw can never land
         and the line would stay frozen on return. Clear the queue and redraw
         the moment the tab is looked at again. */
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) { ticking = false; draw(); }
      });
      draw();

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) e.target.classList.add('is-active');
          });
        },
        { rootMargin: '0px 0px -45% 0px', threshold: 0.01 }
      );
      items.forEach(function (i) { io.observe(i); });
    }

    function boot(scope) {
      var node = scope && scope.querySelectorAll ? scope : document;
      if (node.classList && node.classList.contains('md-lp-expect--line')) init(node);
      [].slice.call(node.querySelectorAll('.md-lp-expect--line')).forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }
    window.addEventListener('load', function () { boot(); });
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

    /* Sections on this page can be swapped in after load, so watch for one
       arriving rather than assuming it was there when this ran. */
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) { boot(); return; }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medistik-media-cards"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-media-carousel]').forEach(function (track) {
    var section = track.closest('.md-media-cards');
    if (!section) return;
    var step = function () {
      var card = track.querySelector('.md-media-card');
      return card ? card.getBoundingClientRect().width + 20 : 400;
    };
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medistik-member-popup"] && !Shopify.designMode) return;
  try {
    
  /**
   * Timed, cookie-gated modal. Audience gating already happened in Liquid, so
   * if this element exists on the page the shopper is eligible; all that is
   * left is the delay, the dismissal cookie, and focus handling.
   *
   * The cookie is keyed on the campaign id, so changing that setting starts a
   * fresh campaign and re-shows the popup to everyone who dismissed the last.
   */
  class MedistikPopup extends HTMLElement {
    #timer = null;
    #lastFocused = null;

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.cookieName = this.dataset.cookie || 'md_popup';
      this.rememberDays = Number(this.dataset.rememberDays) || 30;
      this.designMode = this.dataset.designMode === 'true';

      // Every dismissal route funnels through close(), which writes the cookie
      // itself rather than waiting on the dialog's `close` event. That event is
      // dispatched asynchronously and some engines skip it entirely, and a
      // missed write means the popup returns on the next page load. `close` and
      // `cancel` stay wired as idempotent safety nets.
      this.dialog.addEventListener('close', this.#afterClose.bind(this));
      this.dialog.addEventListener('cancel', this.#markDismissed.bind(this));
      this.dialog.addEventListener('keydown', this.#handleKeydown.bind(this));
      this.dialog.addEventListener('click', this.#handleBackdropClick.bind(this));
      this.querySelector('[data-popup-close]')?.addEventListener('click', () => this.close());
      this.querySelector('[data-popup-cta]')?.addEventListener('click', () => {
        // Remember before the browser leaves the page: a shopper who acted on
        // the offer should not meet the popup again either.
        this.#markDismissed();
      });

      if (this.designMode) {
        this.#bindDesignMode();
        return;
      }

      if (this.#dismissed()) return;

      const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
      this.#timer = window.setTimeout(() => this.open(), delay);
    }

    disconnectedCallback() {
      window.clearTimeout(this.#timer);
    }

    open() {
      if (!this.dialog || this.dialog.open) return;
      this.#lastFocused = document.activeElement;
      this.dialog.showModal();
      // Paint once before flipping the class so the transition actually runs.
      window.requestAnimationFrame(() => this.dialog.classList.add('is-open'));
      this.querySelector('[data-popup-close]')?.focus();
    }

    close() {
      if (!this.dialog?.open) return;
      this.#markDismissed();
      this.dialog.close();
      this.#afterClose();
    }

    #handleKeydown(event) {
      if (event.key !== 'Escape') return;
      // Take Escape over from the native handler so it dismisses on exactly the
      // same path as the close button, cookie included.
      event.preventDefault();
      this.close();
    }

    #afterClose() {
      // Idempotent: reached from close() and again from the `close` event.
      if (!this.dialog.classList.contains('is-open')) return;
      this.dialog.classList.remove('is-open');
      if (this.#lastFocused instanceof HTMLElement && this.#lastFocused.isConnected) {
        this.#lastFocused.focus();
      }
    }

    #handleBackdropClick(event) {
      // A modal dialog's own box is the backdrop area; the panel covers the rest.
      if (event.target === this.dialog) this.close();
    }

    #dismissed() {
      return document.cookie
        .split('; ')
        .some((entry) => entry.startsWith(`${this.cookieName}=`));
    }

    #markDismissed() {
      if (this.designMode) return;
      // `secure` is dropped on http so dismissal still works on the local
      // `shopify theme dev` server, which is not served over TLS.
      const secure = window.location.protocol === 'https:' ? ';secure' : '';
      const maxAge = this.rememberDays * 24 * 60 * 60;
      document.cookie = `${this.cookieName}=1;path=/;max-age=${maxAge}${secure};samesite=lax`;
    }

    #bindDesignMode() {
      const sectionId = this.dataset.sectionId;
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail?.sectionId === sectionId) this.open();
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail?.sectionId === sectionId) this.close();
      });
    }
  }

  if (!customElements.get('medistik-popup')) {
    customElements.define('medistik-popup', MedistikPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medistik-pdp-experts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('medistik-pdp-expert-tabs')) {
    customElements.define('medistik-pdp-expert-tabs', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-expert-tab]');
          if (!tab || !this.contains(tab)) return;
          this.selectTab(tab);
        });

        this.addEventListener('keydown', (event) => {
          const tab = event.target.closest('[data-expert-tab]');
          if (!tab || !this.contains(tab)) return;

          const tabs = Array.from(this.querySelectorAll('[data-expert-tab]'));
          const index = tabs.indexOf(tab);
          let next = null;

          switch (event.key) {
            case 'ArrowRight':
              next = tabs[(index + 1) % tabs.length];
              break;
            case 'ArrowLeft':
              next = tabs[(index - 1 + tabs.length) % tabs.length];
              break;
            case 'Home':
              next = tabs[0];
              break;
            case 'End':
              next = tabs[tabs.length - 1];
              break;
            default:
              return;
          }

          event.preventDefault();
          this.selectTab(next);
          next.focus();
        });
      }

      selectTab(tab) {
        const key = tab.dataset.expertTab;
        this.querySelectorAll('[data-expert-tab]').forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.setAttribute('tabindex', selected ? '0' : '-1');
        });
        this.querySelectorAll('[data-expert-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.expertPanel !== key;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medistik-pdp-science"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('medistik-pdp-science-tabs')) {
    customElements.define(
      'medistik-pdp-science-tabs',
      class MedistikPdpScienceTabs extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.dataset.initialized = 'true';
          this.tabs = Array.from(this.querySelectorAll('[data-science-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-science-panel]'));

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.selectTab(tab));
            tab.addEventListener('keydown', (event) => this.handleKeydown(event));
          });

          const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
          if (selectedTab) this.selectTab(selectedTab);
        }

        selectTab(selectedTab, moveFocus = false) {
          const selectedKey = selectedTab.dataset.scienceTab;

          this.tabs.forEach((tab) => {
            const isSelected = tab === selectedTab;
            tab.setAttribute('aria-selected', String(isSelected));
            tab.tabIndex = isSelected ? 0 : -1;
          });

          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.sciencePanel !== selectedKey;
          });

          if (moveFocus) selectedTab.focus();
        }

        handleKeydown(event) {
          const currentIndex = this.tabs.indexOf(event.currentTarget);
          if (currentIndex < 0) return;

          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = (currentIndex + 1) % this.tabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = this.tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          this.selectTab(this.tabs[nextIndex], true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medistik-pdp-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('medistik-pdp-story-tabs')) {
    customElements.define('medistik-pdp-story-tabs', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-story-tab]');
          if (!tab || !this.contains(tab)) return;

          const key = tab.dataset.storyTab;
          this.querySelectorAll('[data-story-tab]').forEach((item) => {
            item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
          });
          this.querySelectorAll('[data-story-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.storyPanel !== key;
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medistik-product-row"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-product-row-view-more]');
    if (!button) return;
    const more = document.getElementById(button.getAttribute('aria-controls'));
    if (!more) return;
    more.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    button.hidden = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medistik-submit-video"] && !Shopify.designMode) return;
  try {
    
  class MedistikSubmitVideo extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-submit-video-form]');
      if (!this.form) return;

      this.summary = this.querySelector('[data-submit-video-summary]');
      this.summaryList = this.querySelector('[data-submit-video-summary-list]');
      this.status = this.querySelector('[data-submit-video-status]');
      this.button = this.querySelector('[data-submit-video-button]');

      /* Progressive enhancement: without JS the browser's own required/email
         validation still runs, so novalidate is only set once we are ready to
         render the messages ourselves. */
      this.form.setAttribute('novalidate', 'novalidate');
      this.form.addEventListener('submit', this.#onSubmit.bind(this));
      this.form.addEventListener('input', this.#onInput.bind(this));
      this.form.addEventListener('change', this.#onInput.bind(this));
    }

    get #fields() {
      return Array.from(this.form.elements).filter(
        (element) => element.willValidate && element.type !== 'hidden'
      );
    }

    #onInput(event) {
      const field = event.target;
      if (!field.willValidate || field.getAttribute('aria-invalid') !== 'true') return;
      if (field.checkValidity()) this.#clearField(field);
    }

    #onSubmit(event) {
      const invalid = this.#fields.filter((field) => !field.checkValidity());

      this.#fields.forEach((field) => this.#clearField(field));

      if (invalid.length === 0) {
        /* The browser navigates to JotForm's confirmation page. Video files
           are large, so say something while the upload runs. */
        if (this.status) this.status.hidden = false;
        if (this.button) {
          this.button.setAttribute('aria-busy', 'true');
          this.button.disabled = true;
        }
        return;
      }

      event.preventDefault();
      if (this.button) {
        this.button.removeAttribute('aria-busy');
        this.button.disabled = false;
      }
      if (this.status) this.status.hidden = true;

      invalid.forEach((field) => this.#markField(field));
      this.#renderSummary(invalid);
      (this.summary && !this.summary.hidden ? this.summary : invalid[0]).focus();
    }

    #labelFor(field) {
      const label = this.form.querySelector(`label[for="${field.id}"]`);
      const text = label ? label.textContent : '';
      return text.replace(/\s+/g, ' ').replace(/\s*\*\s*/g, '').trim() || field.name;
    }

    #markField(field) {
      field.setAttribute('aria-invalid', 'true');
      const message = this.#errorNode(field);
      if (!message) return;
      message.textContent = field.validationMessage;
      message.hidden = false;
    }

    #clearField(field) {
      field.removeAttribute('aria-invalid');
      const message = this.#errorNode(field);
      if (!message) return;
      message.hidden = true;
      message.textContent = '';
    }

    #errorNode(field) {
      const ids = (field.getAttribute('aria-describedby') || '').split(/\s+/);
      for (const id of ids) {
        const node = id && this.form.querySelector(`#${CSS.escape(id)}`);
        if (node && node.classList.contains('md-submit-video__error')) return node;
      }
      return null;
    }

    #renderSummary(invalid) {
      if (!this.summary || !this.summaryList) return;

      this.summaryList.replaceChildren(
        ...invalid.map((field) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${field.id}`;
          link.textContent = `${this.#labelFor(field)}: ${field.validationMessage}`;
          link.addEventListener('click', (event) => {
            event.preventDefault();
            field.focus();
          });
          item.appendChild(link);
          return item;
        })
      );

      this.summary.hidden = false;
    }
  }

  if (!customElements.get('medistik-submit-video')) {
    customElements.define('medistik-submit-video', MedistikSubmitVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medistik-ugc-marquee"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ugc-toggle]').forEach(function (button) {
    var sectionEl = button.closest('.md-ugc-section');
    if (!sectionEl) return;
    var marquees = sectionEl.querySelectorAll('.md-ugc');
    button.addEventListener('click', function () {
      var paused = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', paused ? 'true' : 'false');
      button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      marquees.forEach(function (marquee) {
        marquee.classList.toggle('md-ugc--paused', paused);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
